export default {
  orgTaxRates: [],
  orgTaxRate: undefined,
};
